module.exports = __webpack_public_path__ + "static/media/email-marketing.3034d0fa.jpg";